import { LifecycleResource } from './lifecycle';
export const TASK = Symbol('TASK');
export class TaskResource extends LifecycleResource {
  // Set via useTask
  // Set during setup/update
  get taskArgs() {
    return this.args.positional;
  }

  get value() {
    return this.currentTask.value ?? this.lastTask?.value;
  }

  setup() {
    this.update();
  }

  update() {
    if (this.currentTask) {
      this.lastTask = this.currentTask;
    }

    this.currentTask = this[TASK].perform(...this.taskArgs);
  }

  teardown() {
    this[TASK].cancelAll();
  }

}